import { generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import { isPseudoPlanID } from "../is-pseudo-plan-id";

/**
 * 在庫・プラン一覧と同じ編集 URL。擬似 planID はプラン編集へ飛ばさない。
 */
export const getPlanEditPath = ({
	hotelID,
	planID,
	isDayTrip,
}: {
	hotelID: string;
	planID: string;
	isDayTrip: boolean;
}): string | null => {
	if (isPseudoPlanID(planID)) {
		return null;
	}
	if (isDayTrip) {
		return generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.DEFAULT, { hotelID, planID });
	}
	return generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DEFAULT, { hotelID, planID });
};
